<template>
  <div id="app" :style="'height:' + appH + 'px'">
       <Aplayer />
       <transition :name="transitionName">
           <router-view v-if="frashKey" @pageFrash="pageFrash" />
       </transition>
       <Toast ref="toast" />
       <Model />
       <FootPlayer v-show="footPlayer"/>
  </div>
</template>

<script>
import Aplayer from "@/components/player";
import Toast from "@/components/Toast";
import Model from "@/components/Model"
import vEmits from "@/utils/vEmits";
import storage from 'good-storage';
import { setOut } from "@/api/login";
import { playHis } from "@/api/song";
import { timeFormate,dateFormate } from "@/utils/utils";

export default {
    components:{
         Aplayer,
         Toast,
         Model
    },
    data(){
         return{
             appH:'',
             transitionName:'',
             frashKey:true,
             footPlayer:false,
             hisState:''
         }
    },
    watch:{
         $route(to,from){
             if(this.hisState || from.name == 'start'){
                 this.transitionName = 'slide-left';
                 this.hisState = '';
             }else{
                 this.transitionName = 'slide-right';
                 if(to.name == from.name){
                      this.pageFrash();
                 }
             }

             this.playerSet(to.name);
         }
    },
    created:function(){
         let vues = this;
         this.appH = document.documentElement.clientHeight;
         this.playerSet(this.$route.name);

         vEmits.$on('rNext',function(){
              vues.hisState = true;
         })

    },
    mounted:function(){
         let vues = this;

         // window.addEventListener('beforeunload',function(){
         //    vues.vueExit();
         // });

         // window.addEventListener('unload',function(){
         //    vues.vueExit();
         // });

         var winW = window.screen.width;

         window.onresize = function(){
             if(winW > 500){
                 if(window.screen.width < 500){
                     vues.$router.replace('index');
                 }else{
                     vues.$router.replace({
                         path:'error',
                         query:{
                             type:3
                         }
                     });
                 }
             }

         }
    },
    methods:{
         pageFrash:function(){
             this.frashKey = false;
             this.$nextTick(function(){
                  this.frashKey = true
             })
         },
         playerSet:function(routeName){
             let noPlayer = {
                 'login':true,
                 'phonecode':true,
                 'codefirm':true,
                 'song':true,
                 'start':true,
                 'error':true,
                 'xybj':true,
                 'hsjd':true,
                 'ctqy':true,
                 'mzzg':true,
                 'xySong':true,
                 'mzSong':true,
                 'redSong':true,
                 'qySong':true

             }
             if(noPlayer[routeName]){
                 this.footPlayer = false;
             }else{
                 this.footPlayer = true;
             }
         },
         getHash:function(){
             return parseInt(Math.random()*100000);
         },
         vueExit:function(){
             let vue = this;
             let userInfo = storage.get('userInfo');
             if(userInfo){
                 setOut();
                 storage.remove('userInfo');
                 let playStore = vue.$store.state.player;
                 playHis({
                     allSecond: playStore.dTime,
                     second: timeFormate(playStore.currentTime,2),
                     code: "LCP",
                     singleId: playStore.songDat[0].icd,
                     source: "wechat",
                     sumDate: dateFormate()
                 })
             }
         }
    }
}
</script>


<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    background: #efefef;
    font-size: 15px;
    overflow-y: scroll;

    transition-property: scrollTop;
    transition-duration: 0.2s;
}

.inner-page{
    position: relative;
    width: 375px;
    overflow-x: hidden;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active{
    will-change: transform;
    transition: all 500ms;
    position: absolute;
}
.slide-right-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}

.slide-frash-enter-active,
.slide-frash-leave-active {
    will-change: transform;
    transition: all 120ms;
    position: absolute;
}

.slide-frash-enter {
    opacity: 0;
    transform: scale(0.95);
}
.slide-frash-leave-active {
    opacity: 0;
    transform: scale(0.95);
}

</style>
